import script from "./StatTile.vue?vue&type=script&setup=true&lang=js"
export * from "./StatTile.vue?vue&type=script&setup=true&lang=js"

import "./StatTile.vue?vue&type=style&index=0&id=82d6f3e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82d6f3e8"]])

export default __exports__